import { module } from 'angular';
import { AttachmentUploadBtnComponent } from './attachment-upload-btn.component';
import { AttachmentUploadModalModule } from '../modals/attachment-uploader-modal/attachment-uploader-modal.module';

export const AttachmentUploadBtnModule = module('app.components.attachment-upload-btn', [
  AttachmentUploadModalModule
])
  .component('attachmentUploader', AttachmentUploadBtnComponent);



// WEBPACK FOOTER //
// ./app/components/attachment-upload-btn/attachment-upload-btn.module.ts